import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { BudgetResponse } from "@/types";

type Props = {
  page?: string | null;
  per_page?: number | null;
  search?: string | null;
  patient_id?: string | null;
};

async function fetchBudgets({
  page,
  per_page,
  search,
  patient_id,
}: Props): Promise<BudgetResponse> {
  const pageParams = `page=${page || 1}&per_page=${per_page || 10}&search=${
    search ?? ""
  }&patient_id=${patient_id ?? ""}`;
  const response = await httpRequest.get<BudgetResponse>(
    `/budgets?${pageParams}`
  );
  return response.data;
}

export function useFetchBudgetsQuery({ page, per_page, search, patient_id }: Props) {
  const budgetsQuery = useQuery({
    queryKey: ["budgets", page, per_page, search, patient_id],
    queryFn: () => fetchBudgets({ page, per_page, search, patient_id }),
    keepPreviousData: true,
  });
  return {
    ...budgetsQuery,
    data: budgetsQuery.data,
  };
}
